import { useEffect } from 'react';

/**
 * Global click handler for anchor links
 * - Handles hash-only links (href="#...") by scrolling to element
 * - Provides fallback to scroll to top if element not found
 * - Works with both internal and external hash links
 */
function GlobalClickHandler() {
  useEffect(() => {
    const handleAnchorClick = (event) => {
      const target = event.target;
      
      // Check if clicked element is an anchor tag or inside one
      const anchor = target.closest('a');
      if (!anchor) return;

      const href = anchor.getAttribute('href');
      
      // Only handle hash links (href="#...")
      if (href && href.startsWith('#')) {
        event.preventDefault();
        
        const hash = href;
        const element = document.querySelector(hash);
        
        console.log('GlobalClickHandler: Hash link clicked', { href, element: element ? element.tagName : 'not found' });
        
        if (element) {
          // Element found, scroll to it smoothly
          element.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start',
            inline: 'nearest'
          });
        } else {
          // Element not found, scroll to top
          console.log('GlobalClickHandler: Element not found, scrolling to top');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    };

    // Add event listener to document
    document.addEventListener('click', handleAnchorClick, true);

    // Cleanup
    return () => {
      document.removeEventListener('click', handleAnchorClick, true);
    };
  }, []);

  return null;
}

export default GlobalClickHandler;
